import {SafeRecord} from '../../types/SafeRecord';
import {DANGEROUS_KEYS} from './DANGEROUS_KEYS';

export function getSafely<T extends SafeRecord, K extends keyof T>(
  obj: T | null | undefined,
  key: K,
  defaultValue?: T[K]
): T[K] | typeof defaultValue {
  if (
    (typeof key !== 'string' && typeof key !== 'number') ||
    DANGEROUS_KEYS.includes(key as (typeof DANGEROUS_KEYS)[number])
  ) {
    throw new Error(`Key cannot be accessed.`);
  }

  if (!obj || typeof obj !== 'object') {
    return defaultValue as T[K] | typeof defaultValue;
  }

  // Use hasOwnProperty to avoid prototype chain - key validated above for dangerous keys
  // eslint-disable-next-line eag/safe-object-access
  return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : defaultValue;
}
